export default __webpack_public_path__ + "static/GESSTwoDWTC-Medium-de09d7cc8a6b97059720355b42ed03e1.woff";